import {parseDate} from "js/common/utils/time";

export const parseTargetDates = target => target
    .update("targetStart", parseDate)
    .update("targetEnd", parseDate);
